import React, { useEffect, useState } from 'react';
import {} from 'antd';
import { getListPage, getSuperFlashsaleList } from 'mod/product-list/service'
import { IFeatureProduct, IFeatureSwiperFlashsaleProducts } from 'mod/feature/interface'
import { LIST_ITEM_TYPE_BANNER } from 'mod/product-list/constant';


type IUseSwiperSeSuperFlashsaleLists = {
    list: any[];
    superFlashSaleList: any[];
    isFetchedList: boolean;
}
type IProps = {
    data: IFeatureProduct | IFeatureSwiperFlashsaleProducts;
}

function useSwiperProducts(props: IProps): IUseSwiperSeSuperFlashsaleLists {
    const {
        data
    } = props
    const {
        config: {
            listLimit = 1,
            superFlashsaleLimit = 10,
        },
        hasSuperFlashsale,
        lists,
        listSn
    } = data as IFeatureSwiperFlashsaleProducts;

    const [superFlashSaleList, setSuperFlashSaleList] = useState<any[]>([])
    const [list, setList] = useState<any[]>([])
    const [isFetchedList, setIsFetchedList] = useState<boolean>(false)


    const getLists = async () => {
        try {
            setIsFetchedList(false)
            const [sListRes, listRes] = await Promise.all([
                !hasSuperFlashsale
                    ? null
                    : getSuperFlashsaleList({
                        pageSize: superFlashsaleLimit
                    }).catch(() => null)
                ,

                !!lists?.length
                    ? null
                    : getListPage({
                        listSn: listSn,
                        pageSize: listLimit
                    }).catch(() => null)
            ])

            setSuperFlashSaleList(sListRes?.list || [])

            let _list: any[] = listRes?.list || lists || []

            _list = _list.filter(item => item?.type !== LIST_ITEM_TYPE_BANNER)
            setList(_list)

        } catch (err) {
        } finally {
            setIsFetchedList(true)
        }
    }

    useEffect(() => {
        getLists().then()
    }, [])

    return {
        list,
        superFlashSaleList,
        isFetchedList
    };
};

export default useSwiperProducts